"use client";

import GeneralAmlErrorPage from "@portal/components/pages/generalAmlErrorPage";
import { useEffect } from "react";
import useCenterId from "@portal/hooks/useCenterId";
import useAdvisor from "@portal/hooks/useAdvisor";
import useFeedHubStreams from "@portal/hooks/useFeedHubStreams";
import useVerifySession from "@portal/hooks/useVerifySession";
import useReInitializedTab from "@portal/hooks/useReInitializedTab";
import useVerifyCustomerAndAmlStatus from "@portal/hooks/useVerifyCustomerAndAmlStatus";
import useLoadInfrontSDK from "@portal/hooks/useLoadInfrontSDK";
import PageSpinner from "@portal/components/molecules/v2/pageSpinner";
import UseAddThemeToBodyElement from "@portal/hooks/useAddThemeToBodyElement";
import { NORNE_CENTERID } from "@portal/assets/banks";
import useInitApp from "@portal/hooks/useInitApp";
import useAmlVerified from "@portal/hooks/useAmlVerified";
import SWRConfigWrapper from "../swrConfigWrapper";
import { IClientSession } from "@portal/pages/api/auth/session/types";

export default function PortalLayoutClientWrapper({
  session,
  children,
}: Readonly<{ session: IClientSession; children: React.ReactNode }>) {
  const centerId = useCenterId();
  const { isAdvisor } = useAdvisor();

  useInitApp({ userId: session?.user?.id, centerId: centerId ?? "" });
  useFeedHubStreams(centerId ?? "");
  useVerifySession();
  useReInitializedTab();

  UseAddThemeToBodyElement({ centerId: centerId ?? NORNE_CENTERID });

  const { amlVerified, error: amlError } = useAmlVerified();
  const { isLoading } = useVerifyCustomerAndAmlStatus();
  // const router = useRouter();

  // TODO
  // useEffect(() => {
  //   const handleComplete = (url: string) => url === router.asPath && appInsights.trackPageView();
  //   router.events.on("routeChangeComplete", handleComplete);
  //   router.events.on("routeChangeError", handleComplete);

  //   return () => {
  //     router.events.off("routeChangeComplete", handleComplete);
  //     router.events.off("routeChangeError", handleComplete);
  //   };
  // });
  useEffect(() => {
    const handleNoScrollAtNumberFields = () => {
      document.addEventListener("wheel", () => {
        if (
          document.activeElement instanceof HTMLElement &&
          document.activeElement.tagName === "INPUT" &&
          document.activeElement.getAttribute("type") === "number"
        ) {
          document.activeElement.blur();
        }
      });
    };
    handleNoScrollAtNumberFields();
  });

  useLoadInfrontSDK();

  if (isLoading) {
    return <PageSpinner />;
  }
  if (amlError && amlError !== 401) {
    return <GeneralAmlErrorPage />;
  }

  return <SWRConfigWrapper>{amlVerified || isAdvisor ? children : <PageSpinner />}</SWRConfigWrapper>;
}
